import { Component } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatDivider } from '@angular/material/list';
import { CookieConsentBarComponent } from '../../../components/cookie-consent-bar/cookie-consent-bar.component';
import { TOSAndPrivacyPolicyComponent } from '../../../terms-of-use-and-privacy-policy/tos-and-privacy-policy.component';

@Component({
	selector: 'app-login-container',
	templateUrl: 'login-container.component.html',
	styleUrls: [
		'../login.component.scss',
		'../../common/main.scss',
		'./login-container.component.scss',
	],
	imports: [
		MatCard,
		MatDivider,
		TOSAndPrivacyPolicyComponent,
		CookieConsentBarComponent,
	],
})
export class LoginContainerComponent {
	constructor() {}
}
